import type { QueryClient } from '@tanstack/react-query';
import { createApiClient, type ApiClient } from './client';
import { createQueryClient } from './queryClient';

/** The API client and query cache for one identity the tab can be. */
export interface IdentityClients {
  api: ApiClient;
  queryClient: QueryClient;
}

/** The clients for viewing as a user, by their ID. */
export type ViewAsClients = (userId: string) => IdentityClients;

/**
 * One API client (sending X-View-As) and one query cache per viewed user, kept for the
 * router's life (ADR 0017's A19 amendment). A separate cache, not keys, keeps one
 * identity's data from ever showing as another's: /users and /view-as/... share a tab.
 */
export function createViewAsClients(onUnauthenticated: () => void): ViewAsClients {
  const clients = new Map<string, IdentityClients>();
  return (userId) => {
    let found = clients.get(userId);
    if (!found) {
      found = {
        api: createApiClient({ viewAs: userId, onUnauthenticated }),
        queryClient: createQueryClient(),
      };
      clients.set(userId, found);
    }
    return found;
  };
}
